const { Component } = Shopware;

Component.extend('neti-ior-cart-listing', 'sw-entity-listing', {

    methods: {
        applyResult(result) {
            this.records = result;
            this.loading = false;
        },

        sort(column) {
            this.lastSortedColumn = column;

            let direction = 'ASC';
            if (this.currentSortBy === this.lastSortedColumn.dataIndex) {
                if (this.currentSortDirection === direction) {
                    direction = 'DESC';
                }
            }

            this.currentSortBy = this.lastSortedColumn.dataIndex;
            this.currentSortDirection = direction;
            this.currentNaturalSorting = this.lastSortedColumn.naturalSorting;

            this.$emit('column-sort', this.lastSortedColumn, this.currentSortDirection);
        },
    }
});